import { combineReducers } from 'redux';
import {
    REPORT_INSTITUTION_LOAD_DATA_SOURCE,
    REPORT_INSTITUTION_LOAD_SELECTED_REPORT,
    REPORT_INSTITUTION_SELECT_CHOICE_OPTION,
    REPORT_INSTITUTION_SET_REPORT_DATA,
    REPORT_INSTITUTION_UNLOAD,
    REPORT_TABLE_ACTIONS,
} from '../utils/constants';
import { composeReducers } from 'common/util/composeReducers';

function selectedReport(state = {}, action) {
    if (action.type === REPORT_INSTITUTION_LOAD_SELECTED_REPORT) {
        return action.payload;
    }
    return state;
}

function dataSources(state = {}, action) {
    if (action.type === REPORT_INSTITUTION_LOAD_DATA_SOURCE) {
        const { dataSource, data, loading } = action.payload;
        return {
            ...state,
            [dataSource]: {
                loading,
                values: data,
            },
        };
    }
    return state;
}

function selectedChoices(state = {}, action) {
    if (action.type === REPORT_INSTITUTION_SELECT_CHOICE_OPTION) {
        const { choice, id } = action.payload;
        return {
            ...state,
            [choice]: id,
        };
    }
    return state;
}

function reportData(state = {}, action) {
    if (action.type === REPORT_INSTITUTION_SET_REPORT_DATA) {
        const { dataKey, value } = action.payload;
        if (!dataKey) {
            return state;
        }
        return {
            ...state,
            [dataKey]: value,
        };
    }
    return state;
}

const reports = combineReducers({
    selectedReport,
    dataSources,
    selectedChoices,
    reportData,
});

const reportsActionMatcher = /^REPORT_INSTITUTION_/;
function reportReducer(state, action) {
    if (action.type !== '@@INIT' && !reportsActionMatcher.test(action.type)) {
        return state;
    }
    if (action.type === REPORT_INSTITUTION_UNLOAD) {
        return {
            ...state,
            institutionReport: reports({}, action),
        };
    }
    return {
        ...state,
        institutionReport: reports(state.institutionReport, action),
    };
}

export function loadingReportDataReducer(state, action) {
    return loadingReportReducer(state, action, {
        actionType: REPORT_TABLE_ACTIONS.LOADING_REPORT_DATA,
        dataKey: 'isLoading',
    });
}

export function loadingCustomizeColumnsReducer(state, action) {
    return loadingReportReducer(state, action, {
        actionType: REPORT_TABLE_ACTIONS.LOADING_CUSTOMIZE_COLUMNS,
        dataKey: 'isLoadingCustomizeColumn',
    });
}

export function loadingEmailConfigReducer(state, action) {
    return loadingReportReducer(state, action, {
        actionType: REPORT_TABLE_ACTIONS.LOADING_EMAIL_CONFIG,
        dataKey: 'isLoadingEmailConfig',
    });
}

export function loadingAddEmailConfigReducer(state, action) {
    return loadingReportReducer(state, action, {
        actionType: REPORT_TABLE_ACTIONS.LOADING_ADD_EMAIL_CONFIG,
        dataKey: 'isLoadingAddEmailConfig',
    });
}

function loadingReportReducer(state, action, typeObject) {
    if (action && action.payload && action.payload.reportType && action.type === typeObject.actionType) {
        const reportType = action.payload.reportType;
        const report = state.report || {};
        const data = report[reportType] || {};
        return {
            ...state,
            report: {
                ...report,
                [reportType]: {
                    ...data,
                    [typeObject.dataKey]: true,
                },
            },
        };
    }

    return state;
}

export function loadedReportDataReducer(state, action) {
    return loadedReportReducer(state, action, {
        actionType: REPORT_TABLE_ACTIONS.LOADED_REPORT_DATA,
        dataKey: 'isLoading',
    });
}

export function loadedCustomizeColumnsReducer(state, action) {
    return loadedReportReducer(state, action, {
        actionType: REPORT_TABLE_ACTIONS.LOADED_CUSTOMIZE_COLUMNS,
        dataKey: 'isLoadingCustomizeColumn',
    });
}

export function loadedEmailConfigReducer(state, action) {
    return loadedReportReducer(state, action, {
        actionType: REPORT_TABLE_ACTIONS.LOADED_EMAIL_CONFIG,
        dataKey: 'isLoadingEmailConfig',
    });
}

export function loadedAddEmailConfigReducer(state, action) {
    return loadedReportReducer(state, action, {
        actionType: REPORT_TABLE_ACTIONS.LOADED_ADD_EMAIL_CONFIG,
        dataKey: 'isLoadingAddEmailConfig',
    });
}

function loadedReportReducer(state, action, typeObject) {
    if (action && action.payload && action.payload.reportType && action.type === typeObject.actionType) {
        const reportType = action.payload.reportType;
        const report = state.report || {};
        const data = report[reportType] || {};
        return {
            ...state,
            report: {
                ...report,
                [reportType]: {
                    ...data,
                    [typeObject.dataKey]: false,
                },
            },
        };
    }

    return state;
}

export function setReportDataReducer(state, action) {
    return setReportReducer(state, action, {
        actionType: REPORT_TABLE_ACTIONS.SET_REPORT_DATA,
        dataKey: 'data',
    });
}

export function setCustomizeColumnsReducer(state, action) {
    return setReportReducer(state, action, {
        actionType: REPORT_TABLE_ACTIONS.SET_CUSTOMIZE_COLUMNS_DATA,
        dataKey: 'customizeColumns',
    });
}

export function setEmailConfigReducer(state, action) {
    return setReportReducer(state, action, {
        actionType: REPORT_TABLE_ACTIONS.SET_EMAIL_CONFIGS,
        dataKey: 'emailConfigData',
    });
}

function getReportDataFromPayload(payloadData) {
    if(payloadData.userDocumentAuditTrails) {
        return payloadData.userDocumentAuditTrails;
    }
    if(payloadData.rows) {
        return payloadData.rows;
    }
    return payloadData;
}

function setReportReducer(state, action, typeObject) {
    if (
        action &&
        action.payload &&
        action.payload.reportType &&
        action.payload.data &&
        action.type === typeObject.actionType
    ) {
        const { reportType, data: payloadData } = action.payload;
        const report = state.report || {};
        const data = report[reportType] || {};
        const reportCount = payloadData.count || payloadData.count === 0 ? { count: payloadData.count } : {};
        let reportData = getReportDataFromPayload(payloadData);
        if(action.payload.reportType && typeObject && typeObject.dataKey =='data')
        {
            reportData = reportData.map(data =>{ 
                if(data.signatureCount != undefined)
                    return {...data,signatureCount:data.signatureCount.toString() };
                else 
                    return data;
            });
        }
        return {
            ...state,
            report: {
                ...report,
                [reportType]: {
                    ...data,
                    ...reportCount,
                    [typeObject.dataKey]: reportData,
                },
            },
        };
    }

    return state;
}

export function resetReportDataReducer(state, action) {
    return resetReportReducer(state, action, {
        actionType: REPORT_TABLE_ACTIONS.RESET_REPORT_DATA,
        dataKey: 'data',
    });
}

export function resetCustomizeColumnsReducer(state, action) {
    return resetReportReducer(state, action, {
        actionType: REPORT_TABLE_ACTIONS.RESET_CUSTOMIZE_COLUMNS,
        dataKey: 'customizeColumns',
    });
}

export function resetEmailConfigsReducer(state, action) {
    return resetReportReducer(state, action, {
        actionType: REPORT_TABLE_ACTIONS.RESET_EMAIL_CONFIGS,
        dataKey: 'emailConfigData',
    });
}

export function resetReportReducer(state, action, typeObject) {
    if (action && action.payload && action.payload.reportType && action.type === typeObject.actionType) {
        const reportType = action.payload.reportType;
        const report = state.report || {};
        const data = report[reportType] || {};
        return {
            ...state,
            report: {
                ...report,
                [reportType]: {
                    ...data,
                    [typeObject.dataKey]: undefined,
                },
            },
        };
    }

    return state;
}


export default composeReducers(
    reportReducer,
    loadingReportDataReducer,
    loadedReportDataReducer,
    setReportDataReducer,
    resetReportDataReducer,
    loadingCustomizeColumnsReducer,
    loadedCustomizeColumnsReducer,
    setCustomizeColumnsReducer,
    resetCustomizeColumnsReducer,
    loadingEmailConfigReducer,
    loadedEmailConfigReducer,
    setEmailConfigReducer,
    resetEmailConfigsReducer,
    loadingAddEmailConfigReducer,
    loadedAddEmailConfigReducer,
);
